import { Rows } from "Components/Layout/Table";

const StudioTable: Rows = {
    id: {
        placeholders: [
            {
                element: 'p',
                size: 1
            }
        ]
    },
    name: {
        placeholders: [
            {
                element: 'p',
                size: [3],
            }
        ]
    },
    status: {
        translated: true,
        i18nKey: 'app.creation_status.',
        placeholders: [
            {
                element: 'p',
                size: [2],
            }
        ]
    },
    actions: {
        className: 'actions',
        sortable: false,
        placeholders: [
            {
                element: 'a',
                size: 2,
            },
        ]
    },
};

export default StudioTable;
